import styled, { css } from 'styled-components'
import * as theme from '../theme'

const headingBase = css`
   margin-top: 0;
   margin-bottom: ${theme.spacing.s};
   font-weight: 700;
   color: ${theme.color.headline};
   line-height: 1.2;
`

export const H1 = styled.h1`
   ${headingBase}
   font-size: ${theme.fontSize.xxl};
   border-bottom: 0;
   text-transform: inherit;
`

export const H2 = styled.h2`
   ${headingBase}
   font-size: ${theme.fontSize.xl};
`

export const H3 = styled.h3`
   ${headingBase}
   font-size: ${theme.fontSize.l};
`

export const H4 = styled.h4`
   ${headingBase}
   font-size: ${theme.fontSize.ml};
`

export const H5 = styled.h5`
   ${headingBase}
   font-size: ${theme.fontSize.m};
`

export const H6 = styled.h6`
   ${headingBase}
   font-size: ${theme.fontSize.sm};
`
